module.exports = __webpack_public_path__ + "facebook-d4b0cd69.png";